import { SEARCH_UI_LOADED, SEARCH_UI_UNABLE_TO_LOAD } from "../types";
import api from "../api";

export const uiLoaded = (uiData) => ({
  type: SEARCH_UI_LOADED,
  uiData,
});

export const uiNotLoaded = (uiDataError) => ({
  type: SEARCH_UI_UNABLE_TO_LOAD,
  uiDataError,
});

export const loadUi = () => (dispatch) =>
  api.user.getSearchUi().then((res) => {
    if (res.status === 200) {
      localStorage.searchUiData = JSON.stringify(res.data.Data);
      if (res.data.Data.Messages && res.data.Data.Messages.length > 0) {
        localStorage.customerMessages = JSON.stringify(res.data.Data.Messages);
      }
      dispatch(uiLoaded(res.data.Data));
      return { data: res.data.Data, uiLoaded: true };
    }
    dispatch(uiNotLoaded(res.data));
    return { uiLoaded: false };
  });

export default loadUi;



// WEBPACK FOOTER //
// ./src/actions/search.js